var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41622 5.64H8.56822V12H7.41622V5.64ZM7.99222 4.416C7.76822 4.416 7.58022 4.344 7.42822 4.2C7.28422 4.056 7.21222 3.88 7.21222 3.672C7.21222 3.464 7.28422 3.288 7.42822 3.144C7.58022 2.992 7.76822 2.916 7.99222 2.916C8.21622 2.916 8.40022 2.988 8.54422 3.132C8.69622 3.268 8.77222 3.44 8.77222 3.648C8.77222 3.864 8.69622 4.048 8.54422 4.2C8.40022 4.344 8.21622 4.416 7.99222 4.416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.add07784.svg";
export { ForwardRef as ReactComponent };